import { useEffect } from "react";
import { apiPublic } from "@/lib/api";

let _cache = null;
let _inFlight = null;

async function fetchSeo() {
    if (_cache) return _cache;
    if (!_inFlight) {
        _inFlight = apiPublic.get("/seo").then(r => {
            _cache = r.data;
            _inFlight = null;
            return r.data;
        }).catch(() => {
            _inFlight = null;
            return null;
        });
    }
    return _inFlight;
}

export function invalidateSeoCache() { _cache = null; }

function upsertMeta(attr, key, content) {
    if (!content) return;
    let el = document.head.querySelector(`meta[${attr}="${key}"]`);
    if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, key);
        document.head.appendChild(el);
    }
    el.setAttribute("content", content);
}

function upsertLink(rel, href) {
    if (!href) return;
    let el = document.head.querySelector(`link[rel="${rel}"]`);
    if (!el) {
        el = document.createElement("link");
        el.setAttribute("rel", rel);
        document.head.appendChild(el);
    }
    el.setAttribute("href", href);
}

export function applySeo(seo) {
    if (!seo) return;
    if (seo.site_title) document.title = seo.site_title;
    upsertMeta("name", "description", seo.site_description);
    upsertMeta("name", "keywords", seo.site_keywords);
    // Open Graph
    upsertMeta("property", "og:type", "website");
    upsertMeta("property", "og:title", seo.og_title);
    upsertMeta("property", "og:description", seo.og_description);
    upsertMeta("property", "og:url", window.location.origin);
    if (seo.og_image_url) upsertMeta("property", "og:image", seo.og_image_url);
    // Twitter
    upsertMeta("name", "twitter:card", "summary_large_image");
    upsertMeta("name", "twitter:title", seo.og_title);
    upsertMeta("name", "twitter:description", seo.og_description);
    if (seo.og_image_url) upsertMeta("name", "twitter:image", seo.og_image_url);
    if (seo.twitter_handle) upsertMeta("name", "twitter:site", seo.twitter_handle);
    if (seo.favicon_url) upsertLink("icon", seo.favicon_url);
}

export function useSeo() {
    useEffect(() => {
        let mounted = true;
        fetchSeo().then(seo => { if (mounted) applySeo(seo); });
        return () => { mounted = false; };
    }, []);
}
